import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../utils/api';
import { STATUS } from '../../../utils/status';
import { GetPayload, workflowState } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/workflowExtraReducer';

const initialState: workflowState = {
    workflow: {},
    collection:{},
    createWorkflowStatus: STATUS.NOT_STARTED,
    createWorkflowLinkStatus: STATUS.NOT_STARTED,
    deleteWorkflowStatus: STATUS.NOT_STARTED,
    updateWorkflowStatus: STATUS.NOT_STARTED,
    getWorkflowStatus: STATUS.NOT_STARTED,
    getWorkflowNodesStatus: STATUS.NOT_STARTED
};

export const createWorkflow = createAsyncThunk(
  'project/company/POST',
  async (payload: any, thunkAPI) => {
    const response = await api.post('project/company/workflow/', payload);
    const { status, data } = response;
    if (status === 201) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
)

export const createWorkflowLink = createAsyncThunk(
  'project/company/stage/POST',
  async (payload: any, thunkAPI) => {
    const response = await api.post('project/company/stage/link/', payload);
    const { status, data } = response;
    if (status === 201) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
)

export const getWorkflowNodes = createAsyncThunk(
  'project/company/stage/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    const { search, page, pageSize, sort, order, id, fields, paginate, project_id,workflow_id } = payload;
    const queryString = new URLSearchParams({
      ...(id && { id }),
      ...(project_id && { project_id }),
      ...(workflow_id && { workflow_id }),
      ...(search && { search }),
      ...(page && { page: page.toString() }),
      ...(pageSize && { page_size: pageSize.toString() }),
      ...(paginate && { paginate: paginate.toString() }),
      ...(sort && { sort }),
      ...(order && { order }),
      ...(fields && { fields })
    }).toString();
    const response = await api.get(`project/company/stage/link?${queryString}`);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
);

export const updateWorkflow = createAsyncThunk(
  'project/company/Stage/patch',
  async (payload: any, thunkAPI) => {
    const response = await api.patch(`project/company/stage/link/`, payload);
    const { status, data } = response;
    if (status === 200) {
      return {data, payload};
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
);

const workflowSlice = createSlice({
  name: 'workflow',
  initialState,
  reducers: {
    setCreateWorkflowStatus(state, action) {
      state.createWorkflowStatus = action.payload
    },
    setUpdateWorkflowStatus(state, action) {
      state.updateWorkflowStatus = action.payload
    },
  },
  extraReducers
});

export const { setUpdateWorkflowStatus, setCreateWorkflowStatus } = workflowSlice.actions;
export default workflowSlice.reducer;